<template>
	<div class="create-page">
		<div class="create-content">
			<el-form ref="form" :model="form" :rules="rules" label-position="top">
				<!-- 申请方信息 -->
				<div class="create-section pb0" v-if="contractLevel || [15, 16].includes(auditStatus)">
					<h3>申请方信息：{{ agentName }}</h3>
				</div>
				<div class="create-section" v-if="form.repairType != '' && contractLevel == false && ![15, 16].includes(auditStatus)">
					<h3>申请方信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="机构类型" prop="applyOrgType">
								<el-select v-model="form.applyOrgType" placeholder="请选择" class="full-width" @change="changeApplyOrgType">
									<el-option
										v-for="option in applyOrgTypeOptions"
										:key="option.value"
										:label="option.label"
										:value="option.value"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div v-if="form.applyOrgType != ''">
							<el-form-item label="1" prop="applyOrgId" class="hidden-label">
								<el-select
									v-model="form.applyOrgId"
									placeholder="请选择"
									class="full-width"
									filterable
									remote
									@change="getApplyUser"
									:remote-method="getApplyList">
									<el-option v-for="option in applyOptions" :key="option.id" :label="option.name" :value="option.id"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<div class="claim-user-box" v-if="applyOrgFlag">
						<el-form-item label="索赔管理员" prop="applyOrgId">
							<div class="claim-user" v-if="applyUserList.length > 0" v-for="(item, i) in applyUserList" :key="item.id">
								{{ item.name && item.tel ? `${item.name}/${item.tel}` : item.name || item.tel }}
							</div>
							<div v-if="applyUserList.length == 0">该机构暂无索赔管理员，无法进行索赔申请</div>
						</el-form-item>
					</div>
				</div>
				<!-- 资料未补齐 -->
				<div class="create-section judge-box" v-if="judgeFlag && judgeList.length > 0 && auditStatus != 16">
					<p>你有之前索赔申请的资料未补齐，请补齐资料后再进行新的索赔申请</p>
					<div v-for="(item, index) in judgeList" :key="index">
						编号：
						{{ item.serialNumber }}
						<el-button type="primary" size="small" @click="handleJudge(item)">原索赔补齐资料</el-button>
					</div>
				</div>
				<div class="create-section judge-box pb0" v-if="judgeFlag && auditStatus == 16">
					<p>资料后补:审批已通过，此次索赔已不限制于之前的资料候补订单。</p>
				</div>
				<!-- 资料审核方 -->
				<div class="create-section" v-if="form.applyOrgId != ''">
					<h3>资料审核方</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="机构类型" prop="auditOrgType">
								<el-select v-model="form.auditOrgType" placeholder="请选择" class="full-width" @change="changeAuditOrgType">
									<el-option label="其它进货代理商" value="1"></el-option>
									<el-option label="理光" value="2"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div v-if="form.auditOrgType == '1' && form.auditOrgType != ''">
							<el-form-item label="1" prop="auditOrgId" class="hidden-label">
								<el-select
									v-model="form.auditOrgId"
									placeholder="请选择"
									class="full-width"
									filterable
									remote
									@change="getMatAuditUser"
									:remote-method="getMatAuditList">
									<el-option v-for="option in auditOptions" :key="option.id" :label="option.name" :value="option.id"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<div class="claim-user-box" v-if="auditOrgFlag && form.auditOrgType == '1'">
						<el-form-item label="资料审核管理员" prop="auditOrgId">
							<div class="claim-user" v-if="auditUserList.length > 0" v-for="(item, i) in auditUserList" :key="item.id">
								{{ item.name && item.tel ? `${item.name}/${item.tel}` : item.name || item.tel }}
							</div>
							<div v-if="auditUserList.length == 0" class="color-red">该机构暂无资料审核管理员</div>
						</el-form-item>
					</div>
				</div>
				<!-- 日志 -->
				<div class="create-section log-section" v-if="logList.length > 0">
					<h3>日志</h3>
					<el-table :data="logList" :header-cell-style="{ color: '#444' }">
						<el-table-column prop="createTime" label="时间" width="160"></el-table-column>
						<el-table-column prop="createUsrCompany" label="执行方"></el-table-column>
						<el-table-column prop="createName" label="执行人" width="120"></el-table-column>
						<el-table-column prop="operNotes" label="事件"></el-table-column>
						<el-table-column prop="remark" label="批注"></el-table-column>
					</el-table>
				</div>
				<!-- 基本信息 -->
				<div class="create-section" v-if="form.applyOrgId != ''">
					<h3>基本信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="机型及开发名" prop="repairDevices">
								<el-cascader v-model="form.repairDevices" :options="repairDeviceOptions" :props="{ value: 'id', label: 'name' }"></el-cascader>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="机号" prop="repairDeviceNumber">
								<el-input v-model="form.repairDeviceNumber" placeholder="请输入机号" @input="handleRepairDeviceNumber"></el-input>
							</el-form-item>
						</div>
					</div>
					<div v-if="claimInfo" class="claimInfo-div">
						<h3>
							保修截至日期,按{{ claimInfoTypes[claimInfo.warrantyExpireType] }}保修：
							<br />
							<span>在保修张数以内</span>
						</h3>
						<el-date-picker
							v-model="claimInfo.warrantyExpireDate"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							type="date"
							disabled></el-date-picker>
					</div>
					<div v-if="warrantyInfo">
						<div class="claimInfo-div">
							<h3>
								保修截至日期,按延保记录保修：
								<br />
								<span>在保修张数以内</span>
							</h3>
							<el-date-picker
								v-model="warrantyInfo.warrantyEndDate"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								type="date"
								disabled></el-date-picker>
						</div>
						<table class="warrantyInfo-table">
							<thead>
								<tr>
									<th>购买经销商名</th>
									<th>服务经销商名</th>
									<th>客户名称</th>
									<th>机型</th>
									<th>机号</th>
									<th>保修起始日期</th>
									<th>首保截止日期</th>
									<th>延保截止日期</th>
									<th>延保年限</th>
									<th>延保到期数</th>
									<th>索赔增扩零件</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{{ warrantyInfo.buyerDealer }}</td>
									<td>{{ warrantyInfo.serviceDealer }}</td>
									<td>{{ warrantyInfo.customerName }}</td>
									<td>{{ warrantyInfo.model }}</td>
									<td>{{ warrantyInfo.machineId }}</td>
									<td>{{ warrantyInfo.warrantyStartDate }}</td>
									<td>{{ warrantyInfo.firstServiceEndDate }}</td>
									<td>{{ warrantyInfo.warrantyEndDate }}</td>
									<td>{{ warrantyInfo.warrantyYears }}</td>
									<td>{{ warrantyInfo.warrantyExpiryCount }}万印</td>
									<td>{{ warrantyInfo.warrantyExpanded }}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="grid-box">
						<div>
							<el-form-item label="安装日期" prop="partsClaimWarranty.installDate">
								<el-date-picker
									v-model="form.partsClaimWarranty.installDate"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									type="date"
									:picker-options="pickerOptions"
									placeholder="请选择安装日期"></el-date-picker>
							</el-form-item>
						</div>
						<div>
							<el-form-item
								label="发票日期(请注意有效发票必须包含机型/销售日期/客户名称与申请索赔资料一致)"
								prop="partsClaimWarranty.invoiceDate"
								class="el-form-item1">
								<el-date-picker
									v-model="form.partsClaimWarranty.invoiceDate"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									type="date"
									:picker-options="pickerOptions"
									placeholder="请选择发票日期"></el-date-picker>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="故障日期" prop="partsClaimWarranty.faultDate">
								<el-date-picker
									v-model="form.partsClaimWarranty.faultDate"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									type="date"
									:picker-options="pickerOptions"
									placeholder="请选择故障日期"></el-date-picker>
							</el-form-item>
						</div>
					</div>
					<div class="grid-box">
						<div>
							<el-form-item label="计数器（黑白）" prop="partsClaimWarranty.blackWhiteCounter">
								<el-input v-model="form.partsClaimWarranty.blackWhiteCounter" placeholder="请输入内容"></el-input>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="计数器（彩色）" prop="partsClaimWarranty.colorCounter">
								<el-input v-model="form.partsClaimWarranty.colorCounter" placeholder="请输入内容"></el-input>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="制版计数器" prop="partsClaimWarranty.plateCounter">
								<el-input v-model="form.partsClaimWarranty.plateCounter" placeholder="请输入内容"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="mr20">
						<el-form-item label="故障现象" prop="partsClaimWarranty.failureSymptom">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimWarranty.failureSymptom"></el-input>
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="故障原因" prop="partsClaimWarranty.failureReason">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimWarranty.failureReason"></el-input>
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="故障处理措施" prop="partsClaimWarranty.failureAction">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimWarranty.failureAction"></el-input>
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="故障处理结果" prop="partsClaimWarranty.failureResult">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimWarranty.failureResult"></el-input>
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="索赔件收货地址" prop="partsClaimWarranty.claimAddress">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimWarranty.claimAddress"></el-input>
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="补充说明栏" prop="partsClaimWarranty.additionalNotes">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimWarranty.additionalNotes"></el-input>
						</el-form-item>
					</div>
				</div>
				<!-- 勾选项 -->
				<div class="create-section" v-if="form.applyOrgId != ''">
					<h3>勾选项</h3>
					<div class="radio-box">
						<p>保修卡是否已登录“理光保修卡管理系统”，且当前填写信息与“保修卡管理系统”一致</p>
						<el-radio v-model="form.partsClaimWarranty.warrantyCardInSystem" label="1">是</el-radio>
						<el-radio v-model="form.partsClaimWarranty.warrantyCardInSystem" label="0">否</el-radio>
					</div>
					<!-- 保修卡 -->
					<div class="upload-box" v-if="form.partsClaimWarranty.warrantyCardInSystem == '0' && form.partsClaimWarranty.warrantyCardInSystem != ''">
						<h4>附件</h4>
						<p>请将申请机号的保修卡登录理光保修卡管理系统或者上传保修卡第一或第三联</p>
						<el-upload
							:action="action"
							:headers="headers"
							:multiple="true"
							:show-file-list="false"
							:before-upload="handleBeforeUpload"
							:on-error="handleError"
							:on-success="(res, file, list) => handleSuccess('warranty', res, file, list)">
							<el-button icon="el-icon-paperclip">上传文件</el-button>
						</el-upload>
						<FileList
							:file-list="cardInSystemFileIdList"
							list-name="cardInSystemFileIdList"
							closable
							@onRemove="handleAttachFileRemove"
							class="mt4"></FileList>
					</div>
				</div>
				<!-- 上传附件 -->
				<div class="create-section" v-if="form.applyOrgId != ''">
					<h3>上传附件</h3>
					<!-- 购机发票或租赁合同 -->
					<div class="upload-box">
						<h4>购机发票或租赁合同</h4>
						<p>发票客户名称与填写的客户名一致并有机型注明、或者备注</p>
						<el-upload
							:action="action"
							:headers="headers"
							:multiple="true"
							:show-file-list="false"
							:before-upload="handleBeforeUpload"
							:on-error="handleError"
							:on-success="(res, file, list) => handleSuccess('purchase', res, file, list)">
							<el-button icon="el-icon-paperclip">上传文件</el-button>
						</el-upload>
						<FileList
							:file-list="purchaseLeaseFileIdList"
							list-name="purchaseLeaseFileIdList"
							closable
							@onRemove="handleAttachFileRemove"
							class="mt4"></FileList>
						<el-form-item label="备注" prop="partsClaimWarranty.purchaseLeaseRemark">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimWarranty.purchaseLeaseRemark"></el-input>
						</el-form-item>
					</div>
					<!-- SMC（系统参数报告） -->
					<div class="upload-box">
						<h4>SMC（系统参数报告）</h4>
						<p>请打印全套SMC（如多功能复印机SP5990-1）后扫描上传</p>
						<el-upload
							:action="action"
							:headers="headers"
							:multiple="true"
							:show-file-list="false"
							:before-upload="handleBeforeUpload"
							:on-error="handleError"
							:on-success="(res, file, list) => handleSuccess('smc', res, file, list)">
							<el-button icon="el-icon-paperclip">上传文件</el-button>
						</el-upload>
						<FileList :file-list="smcFileIdList" list-name="smcFileIdList" closable @onRemove="handleAttachFileRemove" class="mt4"></FileList>
						<el-form-item label="备注" prop="partsClaimWarranty.smcRemark">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimWarranty.smcRemark"></el-input>
						</el-form-item>
					</div>
					<!-- 故障样张或照片，或者备注 -->
					<div class="upload-box">
						<h4>故障样张或照片，或者备注</h4>
						<el-upload
							:action="action"
							:headers="headers"
							:multiple="true"
							:show-file-list="false"
							:before-upload="handleBeforeUpload"
							:on-error="handleError"
							:on-success="(res, file, list) => handleSuccess('failureSample', res, file, list)">
							<el-button icon="el-icon-paperclip">上传文件</el-button>
						</el-upload>
						<FileList
							:file-list="failureSampleFileIdList"
							list-name="failureSampleFileIdList"
							closable
							@onRemove="handleAttachFileRemove"
							class="mt4"></FileList>
						<el-form-item label="备注" prop="partsClaimWarranty.failureSampleRemark">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimWarranty.failureSampleRemark"></el-input>
						</el-form-item>
					</div>
					<!-- 故障零件或耗材（色粉）照片 -->
					<div class="upload-box">
						<h4>故障零件或耗材（色粉）照片</h4>
						<el-upload
							:action="action"
							:headers="headers"
							:multiple="true"
							:show-file-list="false"
							:before-upload="handleBeforeUpload"
							:on-error="handleError"
							:on-success="(res, file, list) => handleSuccess('faultyParts', res, file, list)">
							<el-button icon="el-icon-paperclip">上传文件</el-button>
						</el-upload>
						<FileList
							:file-list="faultyPartsFileIdList"
							list-name="faultyPartsFileIdList"
							closable
							@onRemove="handleAttachFileRemove"
							class="mt4"></FileList>
					</div>
				</div>
				<!-- 客户信息 -->
				<div class="create-section" v-if="form.applyOrgId != ''">
					<h3>客户信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="用户名" prop="partsClaimCustomer.userName">
								<el-input v-model="form.partsClaimCustomer.userName" placeholder="请输入用户名"></el-input>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="联系人姓名" prop="partsClaimCustomer.contactName">
								<el-input v-model="form.partsClaimCustomer.contactName" placeholder="请输入联系人姓名"></el-input>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="用户电话" prop="partsClaimCustomer.userPhone">
								<el-input v-model="form.partsClaimCustomer.userPhone" placeholder="请输入用户电话"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="grid-box grid-box1">
						<div>
							<el-form-item label="省市区" prop="partsClaimCustomer.allAddress">
								<el-cascader
									v-model="form.partsClaimCustomer.allAddress"
									:options="addressOptions"
									:props="{ value: 'code', label: 'name' }"></el-cascader>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="详细地址" prop="partsClaimCustomer.addressDetail">
								<el-input v-model="form.partsClaimCustomer.addressDetail" placeholder="例:xxx路xxx街道xxx号"></el-input>
							</el-form-item>
						</div>
					</div>
				</div>
				<!-- 机器零件信息 -->
				<div class="create-section" v-if="form.repairType != ''">
					<h3>{{ partTitleObj[form.repairType] }}信息</h3>
					<!-- 动态生成的零件信息部分 -->
					<div class="flex part-info-box" v-for="(part, index) in form.partsDetailList" :key="index">
						<div class="flex-1">
							<div class="part-info-item">
								<el-form-item
									:label="`${partTitleObj[form.repairType]}名称`"
									:prop="`partsDetailList.${index}.partsName`"
									:rules="rules.partsDetailList.partsName">
									<el-input v-model="part.partsName" :placeholder="`请输入${partTitleObj[form.repairType]}名称`"></el-input>
								</el-form-item>
								<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
							</div>
							<div class="part-info-item">
								<el-form-item
									:label="`${partTitleObj[form.repairType]}编号`"
									:prop="`partsDetailList.${index}.partsNumber`"
									:rules="rules.partsDetailList.partsNumber">
									<el-input v-model="part.partsNumber" :placeholder="`请输入${partTitleObj[form.repairType]}编号`"></el-input>
								</el-form-item>
								<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
							</div>
							<div class="part-info-item">
								<el-form-item :label="'申请数量'" :prop="`partsDetailList.${index}.partsAmount`" :rules="rules.partsDetailList.partsAmount">
									<el-input v-model="part.partsAmount" placeholder="请输入申请数量"></el-input>
								</el-form-item>
								<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
							</div>
							<div class="delete-btn-box">
								<i class="el-icon-delete-solid" @click="removePartInfo(index)"></i>
							</div>
						</div>
						<div class="flex-1 part-info-box-right"></div>
					</div>
					<el-button type="primary" class="ml20 mt20" @click="addPartInfo">新增{{ partTitleObj[form.repairType] }}</el-button>
				</div>
				<!-- 先行赔付 -->
				<div class="create-section" v-if="form.applyOrgId != '' && form.applyOrgType == '3' && isPrepaidFlag">
					<h3>先行赔付</h3>
					<div class="prepaid-box">
						<p>仅限签订“理光先行赔付协议”的代理商可选，索赔完成后故障件逾期未提交或测试正常将予以罚款，谨慎选择！</p>
						<el-radio v-model="isPrepaid" label="0">否</el-radio>
						<el-radio v-model="isPrepaid" label="1">是</el-radio>
					</div>
				</div>
			</el-form>
		</div>
		<!-- 底部按钮区域 -->
		<div class="create-footer" v-if="form.applyOrgId != ''">
			<div>
				<el-button type="info" @click="handleBack">返回</el-button>
			</div>
			<el-button v-if="form.id" type="danger" @click="handleRevocation">撤销</el-button>
			<el-button type="warning" @click="handleSubmit('0')" v-if="![-2, -3].includes(auditStatus)">暂存</el-button>
			<el-button type="primary" @click="handleSubmit('1')">{{ [-2, -3].includes(auditStatus) ? "重新提交" : submitName }}</el-button>
		</div>
		<!-- 右侧边固定按钮区域 -->
		<div
			class="fixed-btn-box"
			v-if="form.applyOrgId != '' && ![-2, -3, 16].includes(auditStatus)"
			:style="{ right: `calc(10vw - ${judgeFlag ? '108' : '80'}px)` }">
			<el-button type="info" @click="handleBack">返回</el-button>
			<el-button v-if="form.id" type="danger" @click="handleRevocation">撤销</el-button>
			<el-button type="warning" @click="handleSubmit('0')">暂存</el-button>
			<el-button type="primary" @click="handleSubmit('1')">{{ submitName }}</el-button>
		</div>
		<!-- 产品保修期限及例外条款弹框 -->
		<el-dialog title="" :visible.sync="dialogVisible" width="70%">
			<iframe title="产品保修期限及例外条款" src="https://ricohhome.i-unc.com/support/policy#exception" frameborder="0"></iframe>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">已阅读</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { judgeAdditional, getByRepairDeviceNumber } from "@/api/claim";
import { debounce } from "@/utils/debounce";
const defaultSettings = require("@/settings.js");
const hostName = defaultSettings.hostName;
import FileList from "../components/FileList.vue";
export default {
	components: {
		FileList,
	},
	data() {
		return {
			// 产品保修期限及例外条款
			dialogVisible: false,
			// 签约类型
			applyOrgTypeOptions: [
				{
					value: "1",
					label: "网络店",
				},
				{
					value: "2",
					label: "特约维修店",
				},
				{
					value: "3",
					label: "代理商",
				},
				{
					value: "4",
					label: "分部",
				},
			],
			// 申请方信息
			applyOptions: [],
			// 申请方人员信息
			applyUserList: [],
			// 申请方信息
			auditOptions: [],
			// 申请方人员信息
			auditUserList: [],
			// 机型及开发名
			repairDeviceOptions: [],
			// 省市县三级
			addressOptions: [],
			form: {
				repairType: "1", // 索赔的类型 1、保修期内机器零件故障 2、理光单独订购零件 3、商品（耗材故障）
				applyOrgType: "", // 申请方信息-机构类型 1、网络店 2、特约维修店 3、代理商 4、分部
				applyOrgId: "", // 申请方信息 对应的机构id
				auditOrgType: "", // 资料审核方-机构类型 1、其它进货代理商 2、理光
				auditOrgId: "", // 资料审核方 对应的机构id
				repairModelId: "", // 机型及开发名 一级
				repairDeviceId: "", // 机型及开发名 二级
				repairDeviceNumber: "", // 机号
				isSubmit: 0, // 是否提交 0否(表示暂存)  1是(提交索赔)
				repairDevices: [],
				//基本信息
				partsClaimWarranty: {
					installDate: "", // 安装日期
					invoiceDate: "", // 发票日期
					faultDate: "", // 故障日期
					blackWhiteCounter: "", // 计数器（黑白）
					colorCounter: "", // 计数器（彩色）
					plateCounter: "", // 制版计数器
					failureSymptom: "", // 故障现象
					failureReason: "", // 故障原因
					failureAction: "", // 故障处理措施
					failureResult: "", // 故障处理结果
					claimAddress: "", // 索赔件收货地址
					additionalNotes: "", // 补充说明栏
					warrantyCardInSystem: "", // 保修卡是否在系统内 0否 1是
					cardInSystemFileIdList: [], // 保修卡附件列表
					purchaseLeaseFileIdList: [], //购机发票或租赁合同上传文件的id
					purchaseLeaseRemark: "", // 购机发票或租赁合同-备注
					smcFileIdList: [], //SMC（系统参数报告）上传文件的id
					smcRemark: "", // SMC（系统参数报告）-备注
					failureSampleFileIdList: [], //故障样张或照片上传文件的id
					failureSampleRemark: "", // 故障样张或照片-备注
					faultyPartsFileIdList: [], // 故障零件或耗材（色粉）上传文件的id
				},
				// 客户信息
				partsClaimCustomer: {
					// 省市县三级，提交时删除
					allAddress: [],
					userName: "", // 用户名
					contactName: "", // 联系人姓名
					userPhone: "", // 用户电话
					province: "", // 省
					city: "", // 市
					district: "", // 区县
					addressDetail: "", // 详细地址
				},
				// 机器零件信息
				partsDetailList: [],
			},
			rules: {
				repairDevices: [{ required: true, message: "机型及开发名", trigger: "blur" }],
				repairDeviceNumber: [{ required: true, message: "请输入机号", trigger: "blur" }],
				partsClaimWarranty: {
					installDate: [
						{
							required: true,
							message: "请选择安装日期",
							trigger: "blur",
						},
					],
					invoiceDate: [
						{
							required: true,
							message: "请选择发票日期",
							trigger: "blur",
						},
					],
					faultDate: [
						{
							required: true,
							message: "请选择故障日期",
							trigger: "blur",
						},
					],
					blackWhiteCounter: [{ required: true, message: "请输入内容", trigger: "blur" }],
					colorCounter: [{ required: true, message: "请输入内容", trigger: "blur" }],
					plateCounter: [{ required: true, message: "请输入内容", trigger: "blur" }],
					failureSymptom: [{ required: true, message: "请输入内容", trigger: "blur" }],
					failureReason: [{ required: true, message: "请输入内容", trigger: "blur" }],
					failureAction: [{ required: true, message: "请输入内容", trigger: "blur" }],
					failureResult: [{ required: true, message: "请输入内容", trigger: "blur" }],
					claimAddress: [{ required: true, message: "请输入内容", trigger: "blur" }],
				},
				partsClaimCustomer: {
					allAddress: [{ required: true, message: "请选择", trigger: "blur" }],
					userName: [{ required: true, message: "请输入用户名", trigger: "blur" }],
					contactName: [
						{
							required: true,
							message: "请输入联系人姓名",
							trigger: "blur",
						},
					],
					userPhone: [
						{
							required: true,
							message: "请输入用户电话",
							trigger: "blur",
						},
					],
				},
				partsDetailList: {
					partsName: [
						{
							required: true,
							message: "请输入机器零件名称",
							trigger: "blur",
						},
					],
					partsNumber: [
						{
							required: true,
							message: "请输入机器零件编号",
							trigger: "blur",
						},
					],
					partsAmount: [
						{
							required: true,
							message: "请输入申请数量",
							trigger: "blur",
						},
						{
							pattern: /^[1-9]\d*$/,
							message: "数量必须为正整数",
							trigger: "blur",
						},
					],
				},
			},
			// 保修卡附件列表
			cardInSystemFileIdList: [],
			// 购机发票或租赁合同附件列表
			purchaseLeaseFileIdList: [],
			// SMC（系统参数报告）附件列表
			smcFileIdList: [],
			// 故障样张或照片附件列表
			failureSampleFileIdList: [],
			// 故障零件或耗材（色粉）附件列表
			faultyPartsFileIdList: [],
			// 机器零件列表
			partsDetailList: [],
			// 索赔管理员是否显示
			applyOrgFlag: false,
			// 资料审核管理员是否显示
			auditOrgFlag: false,
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			partBtnNameObj: {
				1: "新增机器零件",
				2: "新增订购零件",
				3: "新增商品(耗材)",
			},
			auditStatus: "",
			// 是否先行赔付 0否 1是
			isPrepaid: "0",
			isPrepaidFlag: false, // 是否是先行赔付
			// 是否是网络店
			contractLevel: false,
			agentName: "",
			warrantyInfo: null,
			claimInfo: null,
			claimInfoTypes: {
				1: "购货发票日期",
				2: "理光出库日",
				3: "其他",
			},
			judgeFlag: false,
			judgeList: [],
			submitName: "提交",
			pickerOptions: {
				disabledDate(time) {
					// 禁用今天之后的日期（只能选今天及之前）
					return time.getTime() > Date.now();
				},
			},
			logList: [],
		};
	},
	computed: {
		action() {
			return hostName + "bsi/sysAttachFile/addFileOss";
		},
		headers() {
			const token = sessionStorage.getItem("token") || "";
			return {
				token: token,
			};
		},
		// 是否是超级管理员
		isSuperAdmin() {
			const userInfoStr = window.sessionStorage.getItem("userInfo");
			if (!userInfoStr) return false;
			const userInfo = JSON.parse(userInfoStr);
			if (!userInfo) return false;
			if (userInfo.superAdminFlag === "1") return true;
			return false;
		},
	},
	async mounted() {
		const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
		// 网络店
		if (userInfo.sysAgent.contractLevel == "1410436620354142210") {
			this.form.applyOrgType = "1";
			this.form.applyOrgId = userInfo.agentId;
			this.contractLevel = true;
			this.agentName = userInfo.agentName;
			this.applyUserList = [1, 2, 3];
			// 判断是否存在未结束的资料后补
			const judgeAdditionalResponse = await judgeAdditional({ applyOrgId: this.form.applyOrgId }, false);
			if (judgeAdditionalResponse.data.judgeFlag == "yes") {
				this.judgeFlag = true;
				this.judgeList = judgeAdditionalResponse.data.claimMainList;
				this.submitName = "特批申请";
			} else {
				this.judgeFlag = false;
				this.judgeList = [];
				this.submitName = "提交";
			}
		}
		// 代理商
		else if (userInfo.sysAgent.contractLevel == "1410436558597210114") {
			this.applyOrgTypeOptions = [
				{
					value: "1",
					label: "网络店",
				},
				{
					value: "3",
					label: "代理商",
				},
			];
		}

		// 获取机型及开发名
		this.getRepairDevice();
		// 获取省市县三级
		this.getDataAddr();
		// 获取单个索赔信息
		const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
		if (claimId) {
			this.getClaimWarrantyInfo(claimId);
			this.getAuditLogList(claimId);
		} else {
			this.form.id ? delete this.form.id : "";
		}
	},
	methods: {
		// 获取审核日志
		getAuditLogList(claimId) {
			let self = this;
			self.$request.post("getAuditLogList", false, { id: claimId }, function (r) {
				if (r.code == "0") {
					let logList = [];
					for (const element of r.data) {
						if (element.remark) {
							logList.push(element);
						}
					}
					self.logList = logList;
					console.log("审核日志", self.logList);
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取单个索赔信息
		getClaimWarrantyInfo(claimId) {
			let self = this;
			self.$request.get(`${hostName}parts/partsClaimMain/claimWarranty/${claimId}`, true, {}, function (r) {
				if (r.code == "0") {
					self.$nextTick(() => {
						self.auditStatus = r.data?.currentAudit?.auditStatus;
						self.agentName = r.data.applyOrgName;
						self.form.id = r.data.id;
						self.form.repairType = r.data.repairType;
						self.form.applyOrgType = String(r.data.applyOrgType);
						self.form.applyOrgId = r.data.applyOrgId;
						self.form.auditOrgType = r.data.auditOrgType ? String(r.data.auditOrgType) : "";
						self.form.auditOrgId = r.data.auditOrgId ? String(r.data.auditOrgId) : "";
						self.form.repairDeviceId = r.data.repairDeviceId;
						self.form.repairDeviceNumber = r.data.repairDeviceNumber;
						self.form.partsClaimWarranty = {
							id: r.data.partsClaimWarranty.id, // 安装日期
							installDate: r.data.partsClaimWarranty.installDate, // 安装日期
							invoiceDate: r.data.partsClaimWarranty.invoiceDate, // 发票日期
							faultDate: r.data.partsClaimWarranty.faultDate, // 故障日期
							blackWhiteCounter: r.data.partsClaimWarranty.blackWhiteCounter, // 计数器（黑白）
							colorCounter: r.data.partsClaimWarranty.colorCounter, // 计数器（彩色）
							plateCounter: r.data.partsClaimWarranty.plateCounter, // 制版计数器
							failureSymptom: r.data.partsClaimWarranty.failureSymptom, // 故障现象
							failureReason: r.data.partsClaimWarranty.failureReason, // 故障原因
							failureAction: r.data.partsClaimWarranty.failureAction, // 故障处理措施
							failureResult: r.data.partsClaimWarranty.failureResult, // 故障处理结果
							claimAddress: r.data.partsClaimWarranty.claimAddress, // 索赔件收货地址
							additionalNotes: r.data.partsClaimWarranty.additionalNotes, // 补充说明栏
							warrantyCardInSystem: String(r.data.partsClaimWarranty.warrantyCardInSystem), // 保修卡是否在系统内 0否 1是
							cardInSystemFileIdList: [], // 保修卡附件列表
							purchaseLeaseFileIdList: [], //购机发票或租赁合同上传文件的id
							purchaseLeaseRemark: r.data.partsClaimWarranty.purchaseLeaseRemark, // 购机发票或租赁合同-备注
							smcFileIdList: [], //SMC（系统参数报告）上传文件的id
							smcRemark: r.data.partsClaimWarranty.smcRemark, // SMC（系统参数报告）-备注
							failureSampleFileIdList: [], //故障样张或照片上传文件的id
							failureSampleRemark: r.data.partsClaimWarranty.failureSampleRemark, // 故障样张或照片-备注
							faultyPartsFileIdList: [], // 故障零件或耗材（色粉）上传文件的id
						};
						self.form.partsClaimCustomer = {
							allAddress: [], // 省市县三级
							id: r.data.partsClaimCustomer.id, // 用户名
							userName: r.data.partsClaimCustomer.userName, // 用户名
							contactName: r.data.partsClaimCustomer.contactName, // 联系人姓名
							userPhone: r.data.partsClaimCustomer.userPhone, // 用户电话
							province: r.data.partsClaimCustomer.province, // 省
							city: r.data.partsClaimCustomer.city, // 市
							district: r.data.partsClaimCustomer.district, // 区县
							addressDetail: r.data.partsClaimCustomer.addressDetail, // 详细地址
						};
						let aa = [];
						for (const element of r.data.partsDetailList) {
							aa.push({
								partsAmount: element.partsAmount,
								partsName: element.partsName,
								partsNumber: element.partsNumber,
							});
						}
						self.form.partsDetailList = [...aa];
						// 申请方公司和人员
						self.getApplyList(r.data.applyOrgName);
						self.getApplyUser();
						// 资料审核方公司和人员
						if (r.data.auditOrgType == 1) {
							self.getMatAuditList(r.data.auditOrgName);
							self.getMatAuditUser();
						}

						// 机型及开发名
						r.data.repairModelId ? (self.form.repairDevices = [r.data.repairModelId, r.data.repairDeviceId]) : [];
						// 省市区
						r.data.partsClaimCustomer.province
							? (self.form.partsClaimCustomer.allAddress = [
									r.data.partsClaimCustomer.province,
									r.data.partsClaimCustomer.city,
									r.data.partsClaimCustomer.district,
								])
							: [];
						self.cardInSystemFileIdList = r.data.partsClaimWarranty.cardInSystemFileList || [];
						self.purchaseLeaseFileIdList = r.data.partsClaimWarranty.purchaseLeaseFileList || [];
						self.smcFileIdList = r.data.partsClaimWarranty.smcFileList || [];
						self.failureSampleFileIdList = r.data.partsClaimWarranty.failureSampleFileList || [];
						self.faultyPartsFileIdList = r.data.partsClaimWarranty.faultyPartsFileList || [];
						if (self.auditStatus == 16) {
							self.judgeList = [];
							self.submitName = "特批通过，提交申请";
						}
						if (r.data.repairDeviceNumber) {
							self.handleRepairDeviceNumber();
						}
					});
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 变更申请类型
		changeApplyOrgType() {
			this.form.applyOrgId = "";
			this.applyOrgFlag = false;
			this.applyUserList = [];
			this.getApplyList();
		},
		// 获取申请方信息
		getApplyList(query) {
			let self = this;
			const params = { applyOrgType: self.form.applyOrgType };
			if (query) {
				params.nameLike = query;
			}
			self.$request.post("getApplyList", false, params, function (r) {
				if (r.code == "0") {
					self.applyOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取申请方人员信息
		async getApplyUser() {
			let self = this;
			if (this.auditStatus == 16) {
				self.judgeFlag = true;
				self.judgeList = [];
				self.submitName = "特批通过，提交申请";
			} else {
				const judgeAdditionalResponse = await judgeAdditional({ applyOrgId: self.form.applyOrgId }, false);
				if (judgeAdditionalResponse.data.judgeFlag == "yes") {
					self.judgeFlag = true;
					self.judgeList = judgeAdditionalResponse.data.claimMainList;
					self.submitName = "特批申请";
				} else {
					self.judgeFlag = false;
					self.judgeList = [];
					self.submitName = "提交";
				}
			}

			const params = { agentId: self.form.applyOrgId };
			// 是否先行赔付
			if (this.form.applyOrgType == "3") {
				for (const element of self.applyOptions) {
					if (element.isPrepaid == 1) {
						self.isPrepaid = "0";
						self.isPrepaidFlag = true;
					}
				}
			}
			self.$request.post("getApplyUser", false, params, function (r) {
				if (r.code == "0") {
					self.applyOrgFlag = true;
					self.applyUserList = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		changeAuditOrgType() {
			this.form.auditOrgId = "";
			this.auditOrgFlag = false;
			this.auditUserList = [];
			if (this.form.auditOrgType == "1") {
				this.getMatAuditList();
			}
		},
		// 获取资料审核方信息
		getMatAuditList(query) {
			let self = this;
			const params = {};
			if (query) {
				params.nameLike = query;
			}
			self.$request.post("getMatAuditList", false, params, function (r) {
				if (r.code == "0") {
					self.auditOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取资料审核方人员信息
		getMatAuditUser() {
			let self = this;
			const params = { agentId: self.form.auditOrgId };
			self.$request.post("getMatAuditUser", false, params, function (r) {
				if (r.code == "0") {
					self.auditOrgFlag = true;
					self.auditUserList = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取机型及开发名
		getRepairDevice() {
			let self = this;
			self.$request.get("getRepairDevice", false, {}, function (r) {
				if (r.code == "0") {
					// 删除最后一级的children属性
					for (const element of r.data) {
						for (let index = 0; index < element.children.length; index++) {
							const extAttr = element.children[index];
							delete extAttr.children;
						}
					}
					self.repairDeviceOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取省市县三级
		getDataAddr() {
			let self = this;
			self.$request.get("getDataAddr", false, {}, function (r) {
				if (r.code == "0") {
					self.addressOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 查询延保信息
		handleRepairDeviceNumber: debounce(async function () {
			if (this.form.repairDeviceNumber == "") {
				this.warrantyInfo = null;
				this.claimInfo = null;
				return;
			}
			const res = await getByRepairDeviceNumber({ repairDeviceNumber: this.form.repairDeviceNumber });
			if (res.code == "0") {
				if (res.data.warrantyInfo) {
					this.warrantyInfo = res.data.warrantyInfo;
					this.claimInfo = null;
				}
				if (res.data.claimInfo) {
					this.claimInfo = res.data.claimInfo;
					this.warrantyInfo = null;
				}
				if (res.data.warrantyInfo == null && res.data.claimInfo == undefined) {
					this.warrantyInfo = null;
					this.claimInfo = null;
				}
			} else {
				this.warrantyInfo = null;
				this.claimInfo = null;
			}
		}, 500),
		// 上传前校验
		handleBeforeUpload(file) {
			if (this.isSuperAdmin) {
				// 超管单个文件大小限制1G
				const limitSize = file.size / 1024 / 1024 / 1024 <= 1;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过1G");
					return false;
				}
			} else {
				// 非超管单个文件大小限制255M
				// 2022-07-31 应客户要求改为200M
				const limitSize = file.size / 1024 / 1024 <= 200;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过200M");
					return false;
				}
			}
		},
		// 上传失败回调
		handleError(err, file, fileList) {
			console.log(`handleError`);
			console.log(err);
		},
		// 上传成功回调
		handleSuccess(type, response, file, fileList) {
			console.log(`handleSuccess`);
			if (type === "purchase") {
				this.purchaseLeaseFileIdList.push(file.response.data); // 更新购机发票列表
			} else if (type === "smc") {
				this.smcFileIdList.push(file.response.data); // 更新 SMC 列表
			} else if (type === "failureSample") {
				this.failureSampleFileIdList.push(file.response.data); // 更新 故障样张或照片 列表
			} else if (type === "faultyParts") {
				this.faultyPartsFileIdList.push(file.response.data); // 更新 故障零件或耗材 列表
			} else if (type === "warranty") {
				this.cardInSystemFileIdList.push(file.response.data); // 更新 保修卡 列表
			}
		},
		// 删除上传文件
		handleAttachFileRemove(file, fileListName) {
			this[fileListName].splice(this[fileListName].indexOf(file), 1);
		},
		// 新增机器零件
		addPartInfo() {
			this.form.partsDetailList.push({
				partsName: "",
				partsNumber: "",
				partsAmount: "1",
			});
		},
		// 删除机器零件
		removePartInfo(index) {
			this.form.partsDetailList.splice(index, 1);
		},
		// 返回列表页
		handleBack() {
			this.$router.push({
				path: sessionStorage.getItem("claimRoute"),
			});
		},
		// 暂存/提交  请确认索赔申请资料真实有效以及申请零件在索赔范围内
		handleSubmit: debounce(function (isSubmit) {
			let self = this;
			self.form.isSubmit = isSubmit;
			if (self.form.repairType == "") {
				self.$message.error("索赔类型不能为空");
				return;
			}
			if (self.form.applyOrgType == "" || self.form.applyOrgId == "") {
				self.$message.error("申请方信息不能为空");
				return;
			}
			if (self.form.auditOrgType == "") {
				self.$message.error("请选择资料审批机构");
				return;
			}
			// 选择其它进货代理商必须选公司
			if (self.form.auditOrgType == "1" && self.form.auditOrgId == "") {
				self.$message.error("请选择资料审批机构");
				return;
			}
			// 是否先行赔付
			if (self.form.applyOrgType == "3" && self.isPrepaid == "1") {
				self.form.partsClaimWarranty.isPrepaid = "1";
			} else {
				self.form.partsClaimWarranty.isPrepaid = "0";
			}
			// 保修截至日期 从机号中带出
			if (self.claimInfo) {
				self.form.partsClaimWarranty.warrantyExpireType = self.claimInfo.warrantyExpireType; // 保修截至日期类型 1、按购货发票日期保修 2、按理光出库日保修 3、其他
				self.form.partsClaimWarranty.warrantyExpireDate = self.claimInfo.warrantyExpireDate; // 保修截至日期
				self.form.partsClaimWarranty.warrantyExpireFlag = "1";
			}
			// 保修截至日期 从机号中带出
			if (self.warrantyInfo) {
				self.form.partsClaimWarranty.warrantyExpireType = "3"; // 保修截至日期类型 1、按购货发票日期保修 2、按理光出库日保修 3、其他
				self.form.partsClaimWarranty.warrantyExpireDate = self.warrantyInfo.warrantyEndDate; // 保修截至日期
				self.form.partsClaimWarranty.warrantyExpireFlag = "1";
			}
			// 提交
			if (isSubmit == "1") {
				// 该机构暂无索赔管理员，无法进行索赔申请
				if (self.applyUserList.length == 0) {
					self.$message.error("该机构暂无索赔管理员，无法进行索赔申请");
					return;
				}
				// 该机构暂无资料审核管理员
				if (self.form.auditOrgType == "1" && self.auditUserList.length == 0) {
					self.$message.error("该机构暂无资料审核管理员");
					return;
				}
				// 保修卡不在登录中并且没有上传附件
				if (self.form.partsClaimWarranty.warrantyCardInSystem == "0" && self.cardInSystemFileIdList.length == 0) {
					self.$message.error("请将申请机号的保修卡登录理光保修卡管理系统或者上传保修卡第一或第三联");
					return;
				}
				// 购机发票或租赁合同备注
				if (self.form.partsClaimWarranty.purchaseLeaseRemark == "" && self.purchaseLeaseFileIdList.length == 0) {
					self.$message.error("请上传购机发票或租赁合同，或者备注");
					return;
				}
				// SMC（系统参数报告）
				if (self.form.partsClaimWarranty.smcRemark == "" && self.smcFileIdList.length == 0) {
					self.$message.error("请上传SMC（系统参数报告），或者备注");
					return;
				}
				// 故障样张或照片
				if (self.form.partsClaimWarranty.failureSampleRemark == "" && self.failureSampleFileIdList.length == 0) {
					self.$message.error("请上传故障样张或照片，或者备注");
					return;
				}
				// 故障零件或耗材（色粉）
				if (self.faultyPartsFileIdList.length == 0) {
					self.$message.error("请上传故障零件或耗材（色粉）");
					return;
				}
				// 选择其它进货代理商必须选公司
				if (self.form.partsDetailList.length == 0) {
					self.$message.error(`${self.partTitleObj[self.form.repairType]}不能为空`);
					return;
				}
				let msg = self.judgeFlag
					? `你有之前索赔申请的资料未补齐，请补齐资料后再进行新的索赔申请`
					: `请确认索赔申请资料真实有效以及申请零件在索赔范围内`;
				self.$confirm(msg, "", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				})
					.then(() => {
						self.$refs["form"].validate((valid, fields) => {
							if (valid) {
								self.handleForm();
							} else {
								self.$message.error("维修信息不完整，请完善信息。");
								return false;
							}
						});
					})
					.catch(() => {});
			}
			// 暂存
			else {
				self.handleForm();
			}
		}, 500),
		// 处理form数据
		handleForm() {
			let self = this;
			// 机型及开发名 赋值
			self.form.repairModelId = self.form.repairDevices[0];
			self.form.repairDeviceId = self.form.repairDevices[1];
			// 省市县 赋值
			self.form.partsClaimCustomer.province = self.form.partsClaimCustomer.allAddress[0];
			self.form.partsClaimCustomer.city = self.form.partsClaimCustomer.allAddress[1];
			self.form.partsClaimCustomer.district = self.form.partsClaimCustomer.allAddress[2];
			// // 删除 机型及开发名多级
			// delete self.form.repairDevices;
			// // 删除 省市县
			// delete self.form.partsClaimCustomer.allAddress;
			self.form.partsClaimWarranty.purchaseLeaseFileIdList = [];
			self.form.partsClaimWarranty.smcFileIdList = [];
			self.form.partsClaimWarranty.failureSampleFileIdList = [];
			self.form.partsClaimWarranty.faultyPartsFileIdList = [];
			self.form.partsClaimWarranty.cardInSystemFileIdList = [];

			if (self.purchaseLeaseFileIdList.length > 0) {
				for (const element of self.purchaseLeaseFileIdList) {
					self.form.partsClaimWarranty.purchaseLeaseFileIdList.push(element.id);
				}
			}
			if (self.smcFileIdList.length > 0) {
				for (const element of self.smcFileIdList) {
					self.form.partsClaimWarranty.smcFileIdList.push(element.id);
				}
			}
			if (self.failureSampleFileIdList.length > 0) {
				for (const element of self.failureSampleFileIdList) {
					self.form.partsClaimWarranty.failureSampleFileIdList.push(element.id);
				}
			}
			if (self.faultyPartsFileIdList.length > 0) {
				for (const element of self.faultyPartsFileIdList) {
					self.form.partsClaimWarranty.faultyPartsFileIdList.push(element.id);
				}
			}
			if (self.cardInSystemFileIdList.length > 0 && self.form.partsClaimWarranty.warrantyCardInSystem == "0") {
				for (const element of self.cardInSystemFileIdList) {
					self.form.partsClaimWarranty.cardInSystemFileIdList.push(element.id);
				}
			}

			const postUrl = self.form.id ? "updateClaimWarranty" : "addClaimWarranty";
			if (self.auditStatus == 16) {
				self.form.specialPassSubmit = "yes";
			}
			self.$request.post(postUrl, true, self.form, function (r) {
				if (r.code == "0") {
					console.log(self.form.isSubmit);
					if (self.form.isSubmit == "0") {
						if (postUrl == "addClaimWarranty") {
							sessionStorage.setItem("claimId", r.data.id);
							self.getClaimWarrantyInfo(r.data.id);
						}
						self.$message({
							message: "暂存成功",
							type: "success",
						});
					} else {
						self.$message({
							message: "操作成功",
							type: "success",
						});
						self.handleBack();
					}
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 撤销
		handleRevocation() {
			this.$confirm(`确认撤销此次索赔吗?`, "", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let self = this;
					const params = {
						relatedId: self.form.id,
						auditStatus: "-1",
					};
					self.$request.post("claimWarrantyAuditAdd", true, params, function (r) {
						if (r.code == "0") {
							self.$message({
								message: "操作成功",
								type: "success",
							});
							self.handleBack();
						} else {
							self.$message.error(r.msg);
						}
					});
				})
				.catch(() => {});
		},
		// 跳转补齐资料
		handleJudge(row) {
			sessionStorage.setItem("claimId", row.id);
			sessionStorage.setItem("repairType", row.repairType);
			sessionStorage.setItem("claimInfo", JSON.stringify(row));
			this.$router.push({
				name: "claimDetail",
				query: {
					claimId: row.id,
					repairType: row.repairType,
					menuAction: "1",
				},
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.create-page {
	display: flex;
	flex-direction: column;
}
.create-tab {
	width: 160px;
	border-bottom: 2px solid #409eff;
	text-align: center;
	padding-bottom: 10px;
	margin-bottom: 20px;
}
.create-section {
	padding-bottom: 20px;
	border: 1px solid #ae8d5a;
	border-radius: 8px;
	h3 {
		height: 60px;
		line-height: 60px;
		padding: 0 20px;
		border-bottom: 1px solid #dcdfe6;
	}
}
.type-list {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 20px 20px 0;
	.claim-type {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 34px 20px;
		border-radius: 4px;
		border: 2px solid rgba(0, 0, 0, 0.15);
		font-size: 20px;
		font-weight: 500;
		color: #aaa7a7;
		cursor: pointer;
		.tip {
			margin-top: 10px;
			font-weight: 500;
			font-size: 12px;
			color: #666;
			word-break: break-all;
		}
	}
	.selected {
		border-color: #409eff;
		color: #409eff;
	}
}
.grid-box {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 0 20px;
	.el-cascader,
	.el-date-editor {
		width: 100%;
	}
}
.grid-box1 {
	grid-template-columns: 1fr 2fr; /* 定义列 */
}
/* 使用深度选择器 */
.el-form-item ::v-deep .el-form-item__label {
	padding: 0;
}
.hidden-label ::v-deep .el-form-item__label {
	opacity: 0;
}
.el-form-item1 ::v-deep .el-form-item__label {
	line-height: 20px;
}
.claim-user-box {
	margin: 0 20px;
	button {
		margin-left: 10px;
	}
}
.claim-user {
	color: rgba(0, 0, 0, 0.87);
	border: none;
	cursor: default;
	height: 34px;
	display: inline-flex;
	outline: 0;
	padding: 2px 10px;
	font-size: 0.8125rem;
	box-sizing: border-box;
	transition:
		background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
		box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	align-items: center;
	white-space: nowrap;
	border-radius: 16px;
	vertical-align: middle;
	justify-content: center;
	text-decoration: none;
	background-color: #e0e0e0;
	cursor: pointer;
	img {
		color: transparent;
		width: 100%;
		height: 100%;
		object-fit: cover;
		text-align: center;
		text-indent: 10000px;
	}
}
.radio-box {
	margin: 0 20px;
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
		margin: 10px 0;
	}
}
.el-radio ::v-deep .el-radio__inner {
	width: 20px;
	height: 20px;
}
.el-radio ::v-deep .el-radio__label {
	font-size: 16px;
	color: #000;
}
.upload-box {
	margin: 10px 20px;
	h4,
	p {
		margin-bottom: 10px;
	}
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
	}
}
.upload-box ::v-deep .el-upload-dragger {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 120px;
	width: 120px;
	.el-icon-upload {
		font-size: 40px;
		line-height: unset;
		margin: unset;
	}
}
.create-footer {
	display: flex;
	div {
		flex: 1;
	}
	margin-top: 10px;
}
.fixed-btn-box {
	position: fixed;
	top: 80px;
	right: calc(10vw - 80px);
	button {
		display: block;
		margin-left: 0;
		margin-bottom: 10px;
	}
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
}
.part-info-box {
	margin: 10px 20px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
}
.mt20 {
	margin-top: 20px;
}
.ml20 {
	margin-left: 20px;
}
.color-red {
	color: red;
}
.mr20 {
	margin: 0 20px;
}
.notice {
	color: #409eff;
	display: inline-block;
	text-decoration: underline;
	margin-left: 30px;
	cursor: pointer;
}
iframe {
	width: 100%;
	height: 70vh;
}
.create-page ::v-deep .el-dialog__header {
	display: none;
}
.create-page ::v-deep .el-dialog__body {
	padding: 0;
}
.prepaid-box {
	margin: 10px 20px;
	p {
		margin-bottom: 10px;
	}
}
.pb0 {
	padding-bottom: 0;
}
.claimInfo-div {
	display: flex;
	margin: -5px 0 10px;
	h3 {
		height: unset;
		line-height: unset;
		display: inline-block;
		border: none;
		padding: 0;
		padding-left: 20px;
		span {
			font-size: 12px;
			color: #999;
		}
	}
}
.warrantyInfo-table {
	font-size: 12px;
	width: calc(100% - 40px);
	border-collapse: collapse;
	margin-bottom: 20px;
	margin-left: 20px;
	tr {
		border-top: 1px solid #ddd;
	}

	/* 表头和单元格样式 */
	th,
	td {
		border: 1px solid #ddd; /* 边框颜色 */
		padding: 12px 4px;
		text-align: left;
	}

	/* 表头样式 */
	th {
		background-color: #f2f2f2;
		font-weight: bold;
	}

	// /* 表格行悬停效果 */
	// tr:hover {
	// 	background-color: #f5f5f5;
	// }

	/* 斑马条纹效果 */
	tr:nth-child(even) {
		background-color: #f9f9f9;
	}
}
.judge-box {
	p {
		margin: 20px;
	}
	div {
		margin: 10px 20px;
		.el-button {
			margin-left: 20px;
		}
	}
}
.log-section {
	.el-table {
		margin-left: 20px;
		width: calc(100% - 40px);
		margin-top: 20px;
		font-size: 12px;
	}
}
</style>
<style>
.create-tooltip {
	width: 220px;
}
</style>
